import { render, staticRenderFns } from "./UserProfileModal.vue?vue&type=template&id=29413725&scoped=true&lang=pug&"
import script from "./UserProfileModal.vue?vue&type=script&lang=ts&"
export * from "./UserProfileModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileModal.vue?vue&type=style&index=0&id=29413725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29413725",
  null
  
)

export default component.exports